import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/isAfter/index.js';

var require$$53 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$53 as default };
